import { IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promoteB';

export const gasSignupOptions = [
  'Direct debit optional for hassle-free bill payments',
  'Inbox or letterbox? Your choice for letters and bills',
];

export const defaultSignupOptions = [
  gasSignupOptions[0],
  'Your electricity billed monthly or quarterly',
  gasSignupOptions[1],
];

export const originLoopVPPContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Loop VPP']),
  content: {
    rateChangePrepositionText: {
      VIC: {
        defaultFuel:
          "Our electricity rates will change on 1 August. You'll see your new charges on your next bill after that time.",
        gas: '',
      },
      defaultState: {
        defaultFuel: '',
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [
          'A great feed-in tariff (FIT) rate guaranteed for 12 months',
          'Maximise the value of your solar system',
          'Switch your plan at any time without paying any fees',
        ],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: defaultSignupOptions,
        gas: gasSignupOptions,
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'A higher feed-in tariff, instead of the standard retailer rate',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
